import Nullstack from 'nullstack';
export default function IconTrafficConeOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-traffic-cone-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M4 20h16"
  }), "   ", Nullstack.element("path", {
    d: "M9.4 10h.6m4 0h.6"
  }), "   ", Nullstack.element("path", {
    d: "M7.8 15h7.2"
  }), "   ", Nullstack.element("path", {
    d: "M6 20l3.5 -10.5"
  }), "   ", Nullstack.element("path", {
    d: "M10.5 6.5l.5 -1.5h2l2 6m2 6l1 3"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}